export namespace MessagingQueryKeys {
    const base = "messaging";

    export const LATEST_MESSAGES_INFO = `${base}-latest-messages-info`;

    export const latestMessagesInfo = () => [LATEST_MESSAGES_INFO];
}
